import React from "react";

const BBCMain = React.lazy(() => import("./BBCMain/bbcMain"));
const BBCGuide = React.lazy(() => import("./BBCMain/bbcGuide"));
const BBCSend = React.lazy(() => import("./BBCSend/bbcSend"));
const BbcWait = React.lazy(() => import("./BBCSend/bbcWait"));
const BbcAccept = React.lazy(() => import("./BBCSend/bbcAccept"));
const BBCIntro = React.lazy(() => import("./BBCIntro/bbcIntro"));
const BBCDetail = React.lazy(() => import("./BBCDetail/bbcDetail"));
const BbcReport = React.lazy(() => import("./BBCReport/bbcReport"));
const BBCCompleteMember = React.lazy(() => import("./BBCCompleteMember/bbcCompleteMember"));
const BbcRoute = {
  BBCMain: {
    url: "/bbc/main",
    component: BBCMain,
  },
  BBCGuide: {
    url: "/bbc/guide",
    component: BBCGuide,
  },
  BBCDetail: {
    url: "/bbc/detail",
    component: BBCDetail,
  },
  BBCSend: {
    url: "/bbc/send",
    component: BBCSend,
  },
  BBCAccept: {
    url: "/bbc/accept",
    component: BbcAccept,
  },
  BBCSWait: {
    url: "/bbc/wait",
    component: BbcWait,
  },
  BBCReport: {
    url: "/bbc/report",
    component: BbcReport,
  },
  BBCCompleteMember: {
    url: "/bbc/completeMember",
    component: BBCCompleteMember,
  },
  BBCIntro: {
    url: "/bbc",
    component: BBCIntro,
  },
};
export default BbcRoute;
